import { Injectable } from '@angular/core';

// All hooks loaded in here
import { FullnameHook } from './hooks/fullname.hook';
import { AccountTypeHook } from './hooks/accounttype.hook';
import { CredentialsPasswordHook } from './hooks/credentialspassword.hook';
import { DepositFundsHook } from './hooks/depositfunds.hook';
import { EmploymentStatusHook } from './hooks/employmentstatus.hook';
import { MailAddressHook } from './hooks/mailaddress.hook';
import { OnBlurHook } from './hooks/onblur.hook';
import { TenPercentShareholderHook } from './hooks/tenpercentshareholder.hook';
import { TradingExperienceHook } from './hooks/tradingexperience.hook';
import { YourEmailHook } from './hooks/youremail.hook';

@Injectable()
export class ApplicationHooks {
  constructor() {
    this.hooks = [];
    this._registerHooks();
  }

  _registerHooks() {
    FullnameHook.register(this.hooks);
    AccountTypeHook.register(this.hooks);
    CredentialsPasswordHook.register(this.hooks);
    DepositFundsHook.register(this.hooks);
    EmploymentStatusHook.register(this.hooks);
    MailAddressHook.register(this.hooks);
    OnBlurHook.register(this.hooks);
    TenPercentShareholderHook.register(this.hooks);
    TradingExperienceHook.register(this.hooks);
    YourEmailHook.register(this.hooks);
  }

  execute(path, value, actions) {
    const validHooks = this.hooks[path];

    if (validHooks != null && validHooks.length > 0) {
      validHooks.forEach(hook => {
        hook(path, value, actions);
      });
    }
  }
}
